module.exports = __webpack_public_path__ + "static/media/Your_Plan_has_been_subscribe_now.22c2e1b3.jpg";